import { useState } from "react";
import FormTypeDropdown from "./FormTypeDropdown";

/**
 * Filters for the Templates list. Selections apply as they are made — there is
 * no APPLY button — so the dropdown's own "All" entry is the way back to
 * unfiltered.
 *
 * The customer filter was removed along with the Customer column: a template's
 * customer is only ever set from the Location detail page's Templates section,
 * which is already scoped to one customer, so filtering by it on the main list
 * had nothing to narrow.
 */
const FormTemplateFilterView = ({ onApply }) => {
  const [filterType, setFilterType] = useState("");

  const handleSelect = (val) => {
    const next = val === "" ? "" : String(val);
    setFilterType(next);
    onApply({ filterType: next });
  };

  return (
    <div className="flex items-center gap-6 pb-4">
      <div className="flex items-center gap-2">
        <span className="text-[12px] font-OpenSansMedium font-[600] text-titleColor whitespace-nowrap">
          by Type:
        </span>
        <div className="w-[200px]">
          <FormTypeDropdown
            includeAllOption
            selectedValue={filterType !== "" ? Number(filterType) : null}
            onSelect={handleSelect}
          />
        </div>
      </div>
    </div>
  );
};

export default FormTemplateFilterView;
